import classNames from 'classnames'
import { useWaveSurferVisualizer } from 'hooks/useWaveSurferVisualizer'
import React, { Dispatch, SetStateAction, useEffect } from 'react'

export const VoiceRecorder = ({
  setBtnLabel,
  setFile,
  setFileDuration,
}: {
  setBtnLabel: Dispatch<SetStateAction<string>>
  setFile: Dispatch<SetStateAction<File | null>>
  setFileDuration: Dispatch<SetStateAction<number | null>>
}) => {
  const {
    canvasRef,
    mode,
    startRecording, // 이름 변경
    stopRecording, // 이름 변경
    recordedAudioUrl,
    toggleRecordedPlayback,
    isPlayingRecorded,
    currentTime,
    duration,
    formatTime,
  } = useWaveSurferVisualizer(setFile,setFileDuration)

  useEffect(() => {
    setBtnLabel('녹음 완료')
  }, [])

  useEffect(() => {
    setFileDuration(duration)
  }, [duration])

  return (
    <div className="text-center space-y-4  h-full">
      <ul
        className=" list-disc px-4 py-8 
       text-left bg-[#F6F8FB]  h-[230px] overflow-auto rounded-[10px]"
      >
        <p className="font-bold text-[18px] mb-4">
          🗣️ 아래 10개의 문장을 명확한 발음과 억양으로 잘 읽어서 녹음한 파일을
          업로드 해주세요!
        </p>
        <li className="ml-4 mb-2">
          ‘패스트컷 내 목소리'는, 내 목소리를 녹음하여 내 목소리를 닮은 TTS
          음성을 만드는 서비스입니다.
        </li>
        <li className="ml-4 mb-2">
          이 목소리는 녹음자 본인의 목소리이며, 녹음한 음성을 TTS 생성 목적으로
          사용하는 데 동의합니다.
        </li>
        <li className="ml-4 mb-2">
          이걸 나만 모르고 있었네. 컬러풀한 5가지 색상 커피 텀블러가 있다고 해서
          바로 가져와봤음.
        </li>
        <li className="ml-4 mb-2">
          아니 웬걸. 최고의 시청 경험을 선사하는 제품이 있다고 해서 리뷰를 해
          봤구요. 선명한 화질과 풍부한 색감이 탁월하구요.
        </li>

        <li className="ml-4 mb-2">
          뛰어난 성능과 세련된 디자인을 자랑하는 희대의 아이템을 가져왔다. 장점
          중심으로 빠르게 간다. 무조건 사야 된다!
        </li>
        <li className="ml-4 mb-2">
          와 하루 종일 지속되는 강력한 배터리가 있다고? 오늘의 한줄평 이거 완전
          필수템!
        </li>
        <li className="ml-4 mb-2">
          어 이 제품 뭐지? 인체공학적 디자인으로 진짜 편안해요. 이거는 진짜
          괜찮은데요? 바로 추천 갑니다!
        </li>
        <li className="ml-4 mb-2">
          퇴근 후에 피곤한 나를 도와줄 로봇 청소기! 오늘도 만족을 주니 이
          아이템도 5점 줄게요!
        </li>
        <li className="ml-4 mb-2">
          내가 에센스를 찾고 있었는데 이걸 발견했지 뭐야? 피부 깊숙이 스며드는
          영양감으로 기능성 끝판왕이더라고. 나는 다음에도 또 사고 싶으니 추천!
        </li>
        <li className="ml-4 mb-2">
          이거 한 번 써보세요. 사길 정말 잘했어요. 요리를 쉽고 빠르게 만들 수
          있는 스마트 조리 기구. 정말 만족해요!
        </li>
      </ul>
      <div>
        {/* WaveSurfer가 렌더링될 DOM 요소 */}
        <div
          ref={canvasRef}
          style={{ width: '100%', height: '100%' }}
          className={classNames('', {})}
        ></div>
      </div>
      <div className="flex gap-3 flex-wrap justify-center items-end mt-20">
        {!recordedAudioUrl && mode === 'recording' && (
          <div className="flex gap-10 items-center ">
            <span className="text-[18px]">{formatTime(currentTime)}</span>
            <button
              onClick={stopRecording}
              className={`px-10 py-[23px] text-white rounded-full font-bold flex items-center gap-2 bg-[#FFCBCB]`}
              type="button"
            >
              <span className="fle flex items-center gap-2 text-error">
                <div className=" w-[15px] h-[15px] bg-error box-border"></div>
                <span> 녹음 종료</span>
              </span>
            </button>
          </div>
        )}

        {!recordedAudioUrl && mode === 'idle' && (
          <button
            onClick={startRecording}
            className={`px-10 py-[23px] text-white rounded-full font-bold bg-error  text-[18px] flex items-center gap-2 `}
            type="button"
          >
            <div className=" w-[15px] h-[15px] bg-white rounded-full box-border"></div>
            녹음하기
          </button>
        )}

        {recordedAudioUrl && (
          <>
            <div className="">
              <p className="mb-6">
                녹음된 목소리의 음질과 발음이 좋으면 목소리의 품질이 좋아져요!{' '}
                <br />한 번 들어보시는 것을 추천합니다.
                {currentTime < 20 && (
                  <>
                    <br />{' '}
                    <span className="text-error font-bold">
                      20초 이상 녹음해야합니다!
                    </span>
                  </>
                )}
              </p>
              <div className="flex gap-4 justify-center text-[18px] font-bold">
                <button
                  onClick={toggleRecordedPlayback}
                  className={`px-10 py-[23px] text-white rounded-full font-bold flex items-center gap-2 bg-main min-w-[166px] justify-center`}
                  type="button"
                >
                  <span className="fle flex items-center gap-2 text-white">
                    {' '}
                    {isPlayingRecorded ? (
                      <>
                        {' '}
                        <div className=" w-[15px] h-[15px] bg-white box-border"></div>
                        <span>정지</span>
                      </>
                    ) : (
                      <>
                        {' '}
                        <div
                          className=" w-0 h-0 
                        border-t-[8px] border-t-transparent 
                        border-b-[8px] border-b-transparent 
                        border-l-[14px] border-l-white
                        ml-1"
                        ></div>
                        <span>들어보기</span>
                      </>
                    )}
                  </span>
                </button>

                <button
                  onClick={startRecording}
                  className={`px-10 py-[23px]  rounded-full font-bold flex items-center gap-2 bg-[#D4D9DF] min-w-[166px] justify-center`}
                  type="button"
                >
                  <span>다시 녹음</span>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
